import { getMeasure } from 'config/marketConfig';
import units from 'constants/units';

export const getUnits = () => {
  switch (getMeasure()) {
    case units.imperial:
      return {
        area: 'SF',
        unit: '′',
      };
    case units.metric:
      return {
        area: 'm²',
        unit: 'm',
      };
    default:
      throw Error('getUnits was called with a non existing measure ' + getMeasure());
  }
};
